export default "__VITE_ASSET__DA72xsZf__"